module.exports = __webpack_public_path__ + "img/Pro.d155d191.svg";